import React from 'react';
import { useTranslations } from '@vocab/react';
import { Text, TextLink } from 'braid-design-system';

import translations from '../.vocab';
import {
  EMPLOYER_CONTACT_US_URL,
  SALES_PHONE_NUMBER,
} from '@seek/shared-constants';
import { asiaSites, isAnzSite } from 'src/App/utils/siteConfig';
import type { EmployerSiteName } from 'src/types';
import { useMelwaysLink } from '@seek/melways-react';

interface CustomerServiceMessageProps {
  site: EmployerSiteName;
}
export const CustomerServiceMessage = ({
  site,
}: CustomerServiceMessageProps) => {
  const { t } = useTranslations(translations);
  const localize = useMelwaysLink();

  if (isAnzSite(site)) {
    const csPhoneNumber = SALES_PHONE_NUMBER[site];

    return (
      <Text>
        {t(
          'If the problem persists please call Customer Service on phone number link',
          {
            csPhoneNumber,
            Link: (children) => (
              <TextLink key="csphone" href={`tel:${csPhoneNumber}`}>
                {children}
              </TextLink>
            ),
          },
        )}
      </Text>
    );
  }

  if (asiaSites.includes(site)) {
    return (
      <Text>
        {t('If the problem persists please contact Customer Service', {
          Link: (children) => (
            <TextLink
              key="cslink"
              href={localize({
                path: `${EMPLOYER_CONTACT_US_URL[site]}?enquiry=general`,
              })}
            >
              {children}
            </TextLink>
          ),
        })}
      </Text>
    );
  }
};
